export default __webpack_public_path__ + "4302844173297ae8a8bce88b18d87138.png";